import styled from "@emotion/styled";
import { Gap } from "../../../../common/constants/constants";

export const FormItemsContainer = styled.div({
    display: 'flex',
    flexDirection: 'column',
    gap: Gap.most,
})